<template>
  <div class="e-card e-rounding shadow-sm">
    <h1 class="h3">{{ $t('cashCurrencies.title') }}</h1>

    <Loader v-if="loading"/>

    <div v-if="!loading">
      <p class="text-muted">{{ $t('cashCurrencies.description') }}</p>

      <table class="table table-hover e-table--responsive" v-if="currencies.length > 0">
        <thead>
        <tr>
          <th>{{ $t('cashCurrencies.currencyName') }}</th>
          <th>{{ $t('cashCurrencies.exchangeRate') }}</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(currency, index) in currencies" :key="index">
          <td :data-title="$t('cashCurrencies.currencyName')">
            <input v-model="currency.name" class="form-control" :placeholder="$t('cashCurrencies.currencyNamePlaceholder')" list="iso4217-currencies" autocomplete="off">
          </td>
          <td :data-title="$t('cashCurrencies.exchangeRate')">
            <input v-model="currency.exchangeRate" class="form-control">
          </td>
          <td class="text-right">
            <button @click="removeCurrency(index)" class="btn btn-outline-danger btn-sm">
              <i class="fas fa-trash"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>

      <p v-if="currencies.length === 0" class="text-muted">{{ $t('cashCurrencies.empty') }}</p>

      <datalist id="iso4217-currencies">
        <option v-for="c in iso4217" :key="c" :value="c"></option>
      </datalist>

      <div class="d-flex flex-wrap justify-content-between align-items-center mt-3">
        <button @click="addCurrency()" class="btn btn-outline-secondary m-2">
          <i class="fas fa-plus pr-1"></i>{{ $t('cashCurrencies.addCurrency') }}
        </button>
        <button @click="save()" class="btn btn-primary m-2" :disabled="saving">
          <span v-if="saving" class="spinner-border spinner-border-sm mr-1"></span>
          {{ $t('button.save') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "@/components/Loader"

export default {
  name: 'CashCurrencies',
  components: {Loader},

  data: function () {
    return {
      currencies: [],
      loading: true,
      saving: false,
      iso4217: [
        'AED','AFN','ALL','AMD','ANG','AOA','ARS','AUD','AWG','AZN',
        'BAM','BBD','BDT','BGN','BHD','BIF','BMD','BND','BOB','BRL',
        'BSD','BTN','BWP','BYN','BZD','CAD','CDF','CHF','CLP','CNY',
        'COP','CRC','CUP','CVE','CZK','DJF','DKK','DOP','DZD','EGP',
        'ERN','ETB','EUR','FJD','FKP','GBP','GEL','GHS','GIP','GMD',
        'GNF','GTQ','GYD','HKD','HNL','HRK','HTG','HUF','IDR','ILS',
        'INR','IQD','IRR','ISK','JMD','JOD','JPY','KES','KGS','KHR',
        'KMF','KPW','KRW','KWD','KYD','KZT','LAK','LBP','LKR','LRD',
        'LSL','LYD','MAD','MDL','MGA','MKD','MMK','MNT','MOP','MRU',
        'MUR','MVR','MWK','MXN','MYR','MZN','NAD','NGN','NIO','NOK',
        'NPR','NZD','OMR','PAB','PEN','PGK','PHP','PKR','PLN','PYG',
        'QAR','RON','RSD','RUB','RWF','SAR','SBD','SCR','SDG','SEK',
        'SGD','SHP','SLE','SOS','SRD','SSP','STN','SYP','SZL','THB',
        'TJS','TMT','TND','TOP','TRY','TTD','TWD','TZS','UAH','UGX',
        'USD','UYU','UZS','VES','VND','VUV','WST','XAF','XCD','XOF',
        'XPF','YER','ZAR','ZMW','ZWL',
      ],
    }
  },

  mounted: function () {
    this.refresh();
  },

  methods: {
    refresh: function () {
      const vm = this;
      vm.loading = true;
      this.$http.post('/company/get-cash-currencies')
          .then(function (response) {
            vm.currencies = response.data.currencies || [];
            vm.loading = false;
          });
    },

    addCurrency: function () {
      this.currencies.push({ name: '', exchangeRate: '' });
    },

    removeCurrency: function (index) {
      this.currencies.splice(index, 1);
    },

    save: function () {
      const vm = this;

      for (let i = 0; i < vm.currencies.length; i++) {
        const c = vm.currencies[i];
        if (!c.name || c.name.trim() === '') {
          alert(vm.$t('cashCurrencies.errorNameRequired'));
          return;
        }
        if (!c.exchangeRate || c.exchangeRate.trim() === '') {
          alert(vm.$t('cashCurrencies.errorRateInvalid') + ' ' + c.name);
          return;
        }
      }

      vm.saving = true;
      this.$http.post('/company/set-cash-currencies', {
        currencies: vm.currencies
      })
          .then(function () {
            vm.saving = false;
            vm.refresh();
          }, function () {
            vm.saving = false;
          });
    },
  }
}
</script>
